<template>
    <div>
        <!-- Modal Log Nota Fiscal -->
        <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog" :class="[fileContent ? 'modal-xl' : 'modal-sm', !is_image ? 'modal-dialog-scrollable' : '']" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ocerização</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <az-loading v-if="loading"/>
                    <template v-else>
                        <div class="modal-body">
                            <div class="input-group input-group-sm">
                                <div class="custom-file">
                                    <input
                                        type="file" class="custom-file-input" 
                                        id="inputGroupFile04" aria-describedby="inputGroupFileAddon04"
                                        @change="handle_file_change">
                                    <label class="custom-file-label" for="inputGroupFile04">Selecione o arquivo</label>
                                </div>
                                <div class="input-group-append">
                                    <button :disabled="!can_ocerize" @click="ocerizate_file()" class="btn btn-outline-secondary" type="button" id="inputGroupFileAddon04">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </div>
                            </div>
                            <hr>
                            <div v-if="fileContent">
                                <div v-if="is_image" class="row mt-4">
                                    <div class="sidebar border-right overflow-auto col-md-5 w3-animate-left">
                                        <div class="position-absolute">

                                            <div class="p-2" v-for="(line, index) in textAsArray" :key="index">
                                                <az-input
                                                    sizing="sm"
                                                    placeholder="Procedimento..."
                                                    type="autocomplete"
                                                    service="procedimentos.index"
                                                    optionsMode="aql"
                                                    optionsName="procedimentos.index.guia.ativos"
                                                    :optionsParm="{ ativos: true }"
                                                    ref="info_procedimento"
                                                    v-model="line.procedimento"
                                                >
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button @click="remove(index)" class="btn btn-outline-danger" type="button">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                            <span class="input-group-text" id="basic-addon1">{{line.st_texto}}</span>
                                                        </div>
                                                    </template>
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-append">
                                                            <button @click="add(index)" class="btn btn-outline-secondary" type="button">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>

                                        </div>
                                    </div>
                                    <div id="imageColumn" class="bg-light col-md-7">
                                        <img  style="max-height: 60vh; width: 100%;" :src="fileContent" alt="Uploaded Image">
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="row">
                                        <div v-for="(line, index) in textAsArray" :key="index" class="col col-12 col-md-12 col-lg-12">
                                            <az-input  
                                                sizing="sm"
                                                placeholder="Procedimento..."
                                                type="autocomplete"
                                                service="procedimentos.index"
                                                optionsMode="aql"
                                                optionsName="procedimentos.index.guia.ativos"
                                                :optionsParm="{ ativos: true }"
                                                ref="info_procedimento"
                                                v-model="line.procedimento"
                                            >
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button @click="remove(index)" class="btn btn-outline-danger" type="button">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                        <span class="input-group-text" id="basic-addon1">{{line.st_texto}}</span>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <button @click="add(index)" class="btn btn-outline-secondary" type="button">
                                                            <i class="fas fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="textAsArray" class="modal-footer d-flex justify-content-between">
                            <div></div>
                            <div>
                                <button @click="update_dicionario_pedido()" type="button" class="btn btn-secondary">Atualizar</button>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import AzLoading from '../../../src/components/util/AzLoading.vue'

export default {

    components: {
        AzInput,
        AzLoading
    },
   
    data() {
        return {
            file: null,
            fileId: null,
            fileContent: null,
            text: null,
            textAsArray: null,
            loading: false
        }
    }, 

    computed: {
    
        modal_id() {
            return `modal-ocerization`;
        },

        can_ocerize() {
            return this.file ? true : false;
        },
        
        is_image() {
            return this.file ? this.file.type.includes('image') : false;
        },

        duplicates() {

            const duplicatesMap = {};
            let duplicates = [];

            if(this.textAsArray) {
                const filteredArray = this.textAsArray.filter(item => item.procedimento);
    
                
                filteredArray.forEach(item => {
                    
                    const key = `${item.procedimento.id_procedimento}_${item.st_texto}`;
    
                    if (duplicatesMap[key]) {
                        duplicates.push(item);
                    } else {
                 
                        duplicatesMap[key] = true;
                    }
                    
                });
                return duplicates;

            }

            return [];
        }        

    },

    methods: {

        open_modal() {
            $(`#${this.modal_id}`).modal('show');
        },

        close_modal() {
            $(`#${this.modal_id}`).modal('hide');
        },

        handle_file_change(event) {
            this.file = event.target.files[0];
            this.fileId = this.file.name;
            this.fileContent = null;

            console.log(this.file);
        },

        ocerizate_file() {

            if (!this.file) {
                return;
            }

            this.loading = true;

            let form = new FormData();
            form.append('file', this.file);

            this.axios.post('/ocerizate/exams', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
               
                if(response.data) {

                    const data = response.data;

                    if(data.status_code && data.status_code == 200 && data.array) {
                        
                        this.textAsArray = response.data.array;
                        
                        const reader = new FileReader();
                        reader.onload = () => {
                            // Set the fileContent to the data URL
                            this.fileContent = reader.result;
                        };

                        reader.readAsDataURL(this.file);

                        return;
                    }
                    
                    console.log(data)
                    return this.$toast.add({ 
                        severity: 'error', 
                        summary: 'Erro', 
                        detail: data.msg ? data.msg : 'Erro ao ocerizar imagem',
                        life: 5000, 
                    });
                }

                this.toast.add({ 
                    severity: 'error', 
                    summary: 'Erro', 
                    detail: 'Erro ao ocerizar imagem',
                    life: 5000, 
                })


            }).finally(() => {
                this.loading = false;
            }).catch(error => {
                console.log(error);
            });
            
        },

        add(index) {
            
            let newExam = {
                'exam': null,
                'st_texto': this.textAsArray[index].st_texto,
            }

            return this.textAsArray = [...this.textAsArray.slice(0, index+1), newExam, ...this.textAsArray.slice(index+1)];
        },

        remove(index) {
            this.textAsArray.splice(index, 1);
        },

        update_dicionario_pedido() {
            console.log(this.textAsArray)
            
            if(!this.textAsArray) {
                return;
            }

            if(this.duplicates.length > 0) {
                return this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: this.generate_duplicity_message(),
                    life: 5000, 
                });
            }

            let filteredArray = this.textAsArray.filter(line => line.procedimento).map(line => {
                let object = {
                    'st_texto': line.st_texto,
                    'id_procedimento': line.procedimento.id_procedimento,
                }

                if(line.id_dicionario_pedido) {
                    object.id_dicionario_pedido = line.id_dicionario_pedido;
                }

                return object;            
            });

            console.log(filteredArray)

            if(filteredArray.length === 0) {
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Erro', 
                    detail: 'Nenhum procedimento selecionado',
                    life: 5000, 
                });
                return;
            }

            this.$util.atualizar(this, {
                service: 'dicionario_pedido',
                func: 'store',
                dados: {
                    data: filteredArray,
                },
                callback: (res) => {
                    this.$toast.add({ 
                        severity: res.status_code && res.status_code == 200 ? 'success' : 'error', 
                        summary: res.status_code && res.status_code == 200 ? 'Sucesso' : 'Erro', 
                        detail: res.msg ? res.msg : 'Erro ao atualizar procedimentos',
                        life: 5000, 
                    });
                    this.reset_modal();
                    this.close_modal();
                }
            });

        },

        reset_modal() {
            this.file = null;
            this.fileId = null;
            this.fileContent = null;
            this.text = null;
            this.textAsArray = null;
            this.loading = false;
        },
        
        generate_duplicity_message() {

            let message = 'Procedimentos duplicados:\n';

            message += this.duplicates.map(item => {
                return `[${item.st_texto}] => ${item.procedimento.search},`;
            }).join('\n');

            return message;
        }
    },
}
</script>
<style>
@media (max-width: 770px) {
    .position-absolute {
        position: static !important;
    }
}
</style>